import getCanAutoplaySilentVideo from "selectors/device/getCanAutoplaySilentVideo";
import getCanPlayDash from "selectors/device/getCanPlayDash";
import getIsMobileSafari from "selectors/device/getIsMobileSafari";
import { createSelector } from "reselect";

const getCanControlVolume = createSelector(
  [getCanAutoplaySilentVideo, getCanPlayDash, getIsMobileSafari],
  (canAutoplaySilentVideo, canPlayDash, isMobileSafari) => {
    if (canPlayDash) {
      return true;
    }

    if (!isMobileSafari) {
      return true;
    }

    return canAutoplaySilentVideo;
  },
);

export default getCanControlVolume;
